export default __webpack_public_path__ + "static/media/plus-green.c166fafb.svg";